module.exports = "/_next/static/images/b80e8e6a5bbc4a65b0e467f3c9fb4cc9-locked-deposits@1x.jpg.webp";